import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import colors from 'styles/colors';

const CopyRight: FunctionComponent = () => {
  return (
    <Box
      position="fixed"
      padding={0}
      bottom={2}
      width="100%"
      margin="auto 0"
      bgcolor={colors.base.white}
    >
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        {new Date().getFullYear()} IOMedia Group
      </Typography>
    </Box>
  );
};

export default CopyRight;
